export const video = (theme) => ({
    video: {},
    image: {
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        height: "100%",
    },
    foreground: {
        /* zIndex: 99  --> why is needed here? */
    },
    playerWrapper: {
        position: "relative",
    },
    player: {
        position: "absolute",
        top: "0",
        left: "0",
    },
    playWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        zIndex: 3,
    },
    fullscreenWrapper: {
        display: "grid",
        objectPosition: "center",
        gridTemplate: "auto 1fr / auto",
        width: "100%",
        height: "100%",
        //overflow: "auto",
        backgroundColor: "rgba(0,0,0,0.7)",
    },
    fullscreenVideoWrapper: {
        position: "relative",
        backgroundColor: "black",
        width: "100%",
        height: "100%",
        margin: "auto",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            height: "60vw",
        },
    },
    grow: {
        flexGrow: 1,
    },
    fullscreenBar: {
        position: "relative",
        display: "flex",
        height: 30,
        padding: "0 8px 0 8px !important",
        backgroundColor: "black",
        [theme.breakpoints.down("sm")]: {
            height: 80,
            backgroundColor: "transparent",
        },
    },
    playButtonFullscreenWrapper: {
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
    },
    closeButton: {
        height: "fit-content",
        margin: "auto",
    },
    closeIcon: {
        height: 24,
        width: 24,
    },
    badge: {
        position: "absolute",
        // backgroundColor: theme.customPalette.black,
        fontFamily: "Spezia",
        color: "#ffffff",
        fontSize: 16,
        fontWeight: "bold",
        lineHeight: "22px",
        padding: "16px 8px",
        zIndex: 1,
        width: "100%",
        height: "100%",
        backgroundImage:
            "linear-gradient(to top, #000, rgba(196, 196, 196, 0))",
    },
});

export const videoDescription = (theme) => ({
    VideoDescription: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
        gridGap: theme.spacing(12),
        alignItems: "center",
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
            gridGap: theme.spacing(4),
        },
    },
    editorialContent: {
        paddingRight: theme.spacing(15),
        [theme.breakpoints.down("md")]: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: theme.spacing(0, 1, 0, 1),
        },
    },
    title: {
        [theme.breakpoints.down("md")]: {
            textAlign: "center",
        },
        "&:before": {
            [theme.breakpoints.down("md")]: {
                marginLeft: "auto",
                marginRight: "auto",
            },
        },
    },
    text: {
        paddingTop: theme.spacing(4),
        [theme.breakpoints.down("md")]: {
            lineHeight: "1.57 !important",
            textAlign: "center",
            fontSize: "0.9rem !important",
        },
    },
    videoWrapper: {
        position: "relative",
        height: 430,
        [theme.breakpoints.down("md")]: {
            paddingBottom: "56.25%" /* 16:9 */,
            height: 0,
        },
    },
    video: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
    },
});
